module.exports = __webpack_public_path__ + "static/media/Vogel.7b68d26a.jpg";